import Survey from './container'
export default Survey
